export function getFamilyGroups(memberGroups, familyGroups = []) {
    return Array.from(new Set([
        ...memberGroups.filter((groupName) => /^Group \d+/.test(groupName)),
        ...familyGroups,
    ]));
}
